/**
 * Open a notification's link.
 *
 * Most links are intranet paths and go through the SPA router. Some point at
 * ANOTHER app — HR's new starter bells open the HR app — and the router can
 * only navigate inside this one, so a full http(s) address is a real page
 * load instead. Anything else (no scheme, or a scheme other than http/https)
 * stays inside the router, so a stored `javascript:` link can never run.
 */
import { router } from '@isg/ui-kit';

export function openNotificationUrl(url) {
  if (!url) return;
  if (/^https?:\/\//i.test(url)) {
    window.location.assign(url);
    return;
  }
  router.navigate(url);
}
